export type KcnValue = {
  n: string;
  title: string;
  body: string;
};

/**
 * Single source of truth for the four KCN values.
 * Used by the shared ValuesSection component - do not retype into a page.
 */
export const KCN_VALUES: KcnValue[] = [
  {
    n: "01",
    title: "Grit",
    body: "You're willing to do the hard, unglamorous work. You don't wait to be rescued by a market or a lead source.",
  },
  {
    n: "02",
    title: "Grace",
    body: "You lead with humility. You can be coached. You give people room and you carry yourself with integrity.",
  },
  {
    n: "03",
    title: "Growth",
    body: "You want to be better next year than you are today - as an operator, a leader, a parent, a person of faith.",
  },
  {
    n: "04",
    title: "Give",
    body: "Success isn't success unless it pours back out. Family, community, the agents coming up behind you.",
  },
];

export const VALUES_HEADING_WORDS = KCN_VALUES.map((v) => v.title);
